import { authApi } from './authService';
import { SubtitleConfig, SubtitleTrack } from '@/store/videoFeatures/types/video-features';

export const subtitleService = {
  /**
   * POST /videos/subtitle/:id_video
   * Faz upload de arquivo SRT ou VTT para um vídeo.
   */
  uploadSubtitle: async (
    videoId: string,
    file: File,
    label: string,
    srclang: string,
    isDefault: boolean
  ): Promise<{ subtitle: SubtitleTrack }> => {
    const formData = new FormData();
    formData.append('subtitle', file);
    formData.append('label', label);
    formData.append('srclang', srclang);
    formData.append('isDefault', String(isDefault));

    const response = await authApi.post(`/videos/subtitle/${videoId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * DELETE /videos/subtitle/:id_video/:srclang
   * Remove uma track de legenda de um vídeo.
   */
  deleteSubtitle: async (videoId: string, srclang: string): Promise<void> => {
    await authApi.delete(`/videos/subtitle/${videoId}/${srclang}`);
  },

  /**
   * PUT /videos/subtitle-config/:id_video
   * Salva as configurações de estilo das legendas.
   */
  updateSubtitleConfig: async (
    videoId: string,
    config: SubtitleConfig
  ): Promise<{ subtitleConfig: SubtitleConfig }> => {
    const response = await authApi.put(`/videos/subtitle-config/${videoId}`, config);
    return response.data;
  },
};
